import { render, staticRenderFns } from "./meet_peoples.vue?vue&type=template&id=63e42e82&scoped=true"
import script from "./meet_peoples.vue?vue&type=script&lang=js"
export * from "./meet_peoples.vue?vue&type=script&lang=js"
import style0 from "./meet_peoples.vue?vue&type=style&index=0&id=63e42e82&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e42e82",
  null
  
)

export default component.exports